"use client";

import React, { FC, useState } from "react";
import StaySearchFormSimple from "./(stay-search-form)/StaySearchFormSimple";

export type SearchTab = "Stays" | "Experiences" | "Cars" | "Flights";

export interface HeroSearchFormProps {
  className?: string;
  currentTab?: SearchTab;
  currentPage?: SearchTab;
}

const HeroSearchForm: FC<HeroSearchFormProps> = ({
  className = "",
  currentTab = "Stays",
}) => {
  const tabs: SearchTab[] = ["Stays"]; // still only rendering Stays for now
  const [tabActive, setTabActive] = useState<SearchTab>(currentTab);

  const renderTab = () => {
    return (
      <ul className="flex justify-center space-x-6 mb-6">
        {tabs.map((tab) => {
          const active = tab === tabActive;
          return (
            <li
              key={tab}
              onClick={() => setTabActive(tab)}
              className={`flex items-center cursor-pointer text-sm md:text-base font-medium ${
                active
                  ? "text-gray-900 dark:text-white"
                  : "text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              }`}
            >
              {active && (
                <span className="block w-2.5 h-2.5 rounded-full bg-gray-900 dark:bg-white mr-2" />
              )}
              {tab}
            </li>
          );
        })}
      </ul>
    );
  };

  const renderForm = () => {
    switch (tabActive) {
      case "Stays":
        return <StaySearchFormSimple />;
      // you can add other forms later:
      // case "Experiences": return <ExperiencesSearchForm />;
      // case "Cars": return <CarSearchForm />;
      // case "Flights": return <FlightSearchForm />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`nc-HeroSearchForm w-full max-w-4xl mx-auto px-4 py-8 lg:py-12 ${className}`}
    >

      {renderForm()}
    </div>
  );
};

export default HeroSearchForm;
